/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { MediaAudioWaveIcon16Light } from './MediaAudioWaveIcon16Light';
import { MediaAudioWaveIcon16Regular } from './MediaAudioWaveIcon16Regular';
import { MediaAudioWaveIcon16Solid } from './MediaAudioWaveIcon16Solid';
import { MediaAudioWaveIcon20Light } from './MediaAudioWaveIcon20Light';
import { MediaAudioWaveIcon20Regular } from './MediaAudioWaveIcon20Regular';
import { MediaAudioWaveIcon20Solid } from './MediaAudioWaveIcon20Solid';
import { MediaAudioWaveIcon24Regular } from './MediaAudioWaveIcon24Regular';
import { MediaAudioWaveIcon24Solid } from './MediaAudioWaveIcon24Solid';
import { MediaAudioWaveIcon32Regular } from './MediaAudioWaveIcon32Regular';
import { MediaAudioWaveIcon64Regular } from './MediaAudioWaveIcon64Regular';
var sizes = {
    16: {
        light: MediaAudioWaveIcon16Light,
        regular: MediaAudioWaveIcon16Regular,
        solid: MediaAudioWaveIcon16Solid,
    },
    20: {
        light: MediaAudioWaveIcon20Light,
        regular: MediaAudioWaveIcon20Regular,
        solid: MediaAudioWaveIcon20Solid,
    },
    24: {
        regular: MediaAudioWaveIcon24Regular,
        solid: MediaAudioWaveIcon24Solid,
    },
    32: {
        regular: MediaAudioWaveIcon32Regular,
    },
    64: {
        regular: MediaAudioWaveIcon64Regular,
    },
};
export var MediaAudioWaveIcon = forwardRef('MediaAudioWaveIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
